import { createAction, props } from '@ngrx/store';

//Actions for login user.
export const login = createAction('[Auth/API] Login', props<{ payload: any }>());
export const loginSuccess = createAction(
  '[Auth/API] Login Success',
  props<{
    profile?: any;
    tokenClaim: any;
    isLoggedIn?: any;
    isFlag?: any;
    isTokenUpdate?: any;
    sessionId?: any;
  }>()
);
export const loginFailure = createAction(
  '[Auth/API] Login Failure',
  props<{ error: any; messageType: number }>()
);

//Actions for register user.
export const register = createAction(
  '[Auth/API] register',
  props<{ payload: any; purchaseType: any }>()
);
export const registerSuccess = createAction(
  '[Auth/API] register Success',
  props<{ isRegistered: any; purchaseType: any }>()
);
export const registerFailure = createAction('[Auth/API] register Failure', props<{ error: any }>());

//Actions for get Ip user.
export const getIpAddress = createAction('[Auth/API] Ip');
export const getIpAddressSuccess = createAction(
  '[Auth/API] Ip success',
  props<{ ipAdressData: any }>()
);
export const getIpAddressFailuer = createAction('[Auth/API] Ip Failure', props<{ error: any }>());

//Actions for logout user.
export const logout = createAction('[Auth/API] logout');
export const logoutSuccess = createAction(
  '[Auth/API] Logout Success',
  props<{ isLoggedOut: boolean }>()
);
export const logoutFailure = createAction('[Auth/API] Logout Failure', props<{ error: any }>());
export const clearLoginData = createAction('[Auth/API] clear login data Failure');

//Actions for forgotPassword .
export const forgotPassword = createAction('[Auth/API] forgotPassword', props<{ payload: any }>());
export const forgotPasswordSuccess = createAction(
  '[Auth/API] forgotPassword Success',
  props<{ forgotPasswordData: any; isForgotPassword: boolean }>()
);
export const forgotPasswordFailure = createAction(
  '[Auth/API] forgotPassword Failure',
  props<{ error: any }>()
);

//Actions for changePassword .
export const changePassword = createAction('[Auth/API] changePassword', props<{ payload: any }>());
export const changePasswordSuccess = createAction(
  '[Auth/API] changePassword Success',
  props<{ changePasswordData: any; isForcePassword: any; passwordUpdated: boolean }>()
);
export const changePasswordFailure = createAction(
  '[Auth/API] changePassword Failure',
  props<{ error: any }>()
);

//Actions for resetPassword .
export const resetPassword = createAction('[Auth/API] resetPassword', props<{ payload: any }>());
export const resetPasswordSuccess = createAction(
  '[Auth/API] resetPassword Success',
  props<{ resetPasswordData: any }>()
);
export const resetPasswordFailure = createAction(
  '[Auth/API] resetPassword Failure',
  props<{ error: any }>()
);

export const clearErrorMessage = createAction('[Shared/API] Clear Email Validation');

//Actions for activeUser .
export const activeUser = createAction(
  '[Auth] Active User',
  props<{ payload: any; activationType?: string }>()
);

export const activeUserSuccess = createAction(
  '[Auth/API] activeUser Success',
  props<{ activeUSerStatus: any }>()
);
export const activeUserFailure = createAction(
  '[Auth/API] activeUser Failure',
  props<{ error: any }>()
);

//Actions for Thanks page
export const payment = createAction('[Auth/API] payment', props<{ payload: any }>());
export const paymentSuccess = createAction(
  '[Auth/API] payment Success',
  props<{ paymentStatus: any }>()
);
export const paymentFailure = createAction('[Auth/API] payment Failure', props<{ error: any }>());

// Actions for show verify otp page
export const showOtpPage = createAction(
  '[Auth/API] show verify otp',
  props<{ showOtpPage: boolean; userId?: number | string }>()
);
export const verifyOtp = createAction(
  '[Auth/API] verify otp ',
  props<{ otpNumber: number | string; userId: string; ipAddress: any }>()
);
export const verifyOtpFailure = createAction(
  '[Auth/API] verify Failure',
  props<{ error: any; messageType: number | null }>()
);
export const clearVerifyError = createAction('[Auth/API] clear verify error');

export const clearLoginMessageError = createAction('[Auth/API] clear login error');
export const passwordUpdated = createAction('[Auth/API] forceful password update');

export const maxLoginAttemptsReached = createAction('[Auth] Max Login Attempts Reached');
export const clearMaxLoginAttempts = createAction('[Auth] Clear Max Login Attempts Reached');
